module.exports = __webpack_public_path__ + "static/media/codebot_head.a49c50b5.svg";